import React from 'react'
import { ClipboardDocumentIcon } from '@heroicons/react/24/outline'

const QuickStartSection = ({ copyToClipboard, setActiveTab, userInfo }) => {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200">
      <div className="px-6 py-4 border-b border-gray-200">
        <div>
          <h3 className="text-lg font-semibold text-gray-900">Quick Start</h3>
          <p className="text-sm text-gray-600 mt-1">Get started with the API endpoint</p>
        </div>
      </div>
      <div className="p-6">
        <div className="mb-6">
          <div className="bg-gray-900 rounded-lg p-4 mb-4 relative">
            <div className="absolute top-3 right-3">
              <button
                onClick={() => copyToClipboard(`curl --location 'https://api.easyappicon.com/generate' \\
  --header 'Content-Type: application/json' \\
  --header 'Authorization: YOUR_API_KEY' \\
  --data '{
    "uploadedImage": "data:image/png;base64,YOUR_BASE64_IMAGE",
    "userId": "${userInfo?.id || '8756a28a-53d5-483a-b276-651e76893218'}",
    "backgroundColor": "#000000",
    "iconName": "ic_launcher",
    "padding": 0,
    "showBadge": false,
    "badgeText": "",
    "badgeColor": "#000000",
    "format": "png"
  }'`, 'cURL example')}
                className="text-gray-400 hover:text-white transition-colors"
                title="Copy to clipboard"
              >
                <ClipboardDocumentIcon className="h-4 w-4" />
              </button>
            </div>
            <pre className="text-green-400 text-xs overflow-x-auto pr-8">
{`curl --location 'https://api.easyappicon.com/generate' \\
  --header 'Content-Type: application/json' \\
  --header 'Authorization: YOUR_API_KEY' \\
  --data '{
    "uploadedImage": "data:image/png;base64,YOUR_BASE64_IMAGE",
    "userId": "${userInfo?.id || '8756a28a-53d5-483a-b276-651e76893218'}",
    "backgroundColor": "#000000",
    "iconName": "ic_launcher",
    "padding": 0,
    "showBadge": false,
    "badgeText": "",
    "badgeColor": "#000000",
    "format": "png"
  }'`}
            </pre>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-6">
          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={() => setActiveTab('api-docs')}
              className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors text-center font-medium"
            >
              View Code Examples
            </button>
            <button
              className="border border-gray-300 text-gray-700 px-6 py-3 rounded-lg hover:bg-gray-50 transition-colors text-center font-medium"
              onClick={() => copyToClipboard('https://api.easyappicon.com', 'Base URL')}
            >
              Copy Base URL
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default QuickStartSection
